import { createSlice } from '@reduxjs/toolkit';
import { loginUser } from './auth.actions';

const initialState = {
  isLoadingLogin: false,
  loginErrors: {},
  registerErrors: {},
  formErrors: {},

  registerEmail: '',
  twoFaData: {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setFormErrors: (state, action) => {
      state.formErrors = action.payload;
    },
    setLoginErrors: (state, action) => {
      state.loginErrors = action.payload;
    },
    setRegisterErrors: (state, action) => {
      state.registerErrors = action.payload;
    },
    setRegisterEmail: (state, action) => {
      state.registerEmail = action.payload;
    },
    setTwoFaData: (state, action) => {
      state.twoFaData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state) => {
      state.isLoadingLogin = true;
    });
    builder.addCase(loginUser.fulfilled, (state) => {
      state.isLoadingLogin = false;
    });
    builder.addCase(loginUser.rejected, (state) => {
      state.isLoadingLogin = false;
    });
  },
});

export const { setFormErrors, setLoginErrors, setRegisterErrors, setRegisterEmail, setTwoFaData } =
  authSlice.actions;

export default authSlice.reducer;
